import React, { useState, useEffect, useContext } from 'react';
import apiClient from '../../../api/apiClient';
import { AuthContext } from '../../AuthContext';
import { Modal, Button, Form, Spinner, Alert } from 'react-bootstrap'; // Keeping react-bootstrap Modal and Form for functionality
import AppPaginator from '../../AppPaginator';
import { destroyUom, destroyUomsMultiple, fetchUom, getUoms } from '../../../api/UomsAPI';
import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import AppSearchBox from '../../AppSearchBox';
import UomsReport from './UomsReport';
// import UomsForm from './UomsForm';
import { useLocation, useNavigate } from 'react-router-dom';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import PerPageBlock from '../../common/PerPageBlock';
// import { Modal, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { getAvatar } from '../../../commonfunctions';
import { Can } from '../../../hooks/usePermissions';


const UomsPage = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = location.state?.message;


  const { uom } = useContext(AuthContext); // Get uom data from context
  console.log("uom",uom);
  
  const [entityName, setEntityName] = useState('Uom');
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [reportLoading, setReportLoading] = useState(false);
  const [viewDataLoading, setViewDataLoading] = useState(false);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [searchTermCompleted, setSearchTermCompleted] = useState('');
  const [perPage, setPerPage] = useState(process.env.REACT_APP_PER_PAGE_COUNT);
  const [enableMultipleItemSelect, setEnableMultipleItemSelect] = useState(false);


  const [uomsList, setUomsList] = useState({
    paginate: true,
    data: [],
    per_page: perPage,
    tot_page: null,
  });



  const [toaster, setToaster] = useState({ type: '', heading: '', message: '' });
  const [showToaster, setShowToaster] = useState(false);
  const [saveCompleted, setSaveCompleted] = useState(false);
  const [viewButtonToggle, setViewButtonToggle] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [deleteUomId, setDeleteUomId] = useState(null);
  const [formType, setFormType] = useState(null);
  const [selectedUomIds, setSelectedUomIds] = useState(new Set());
  const [deletingUomsMultiple, setDeletingUomsMultiple] = useState({});

  console.log("selectedUomIds", selectedUomIds.length);

  // Function to handle opening the edit modal

  const handleAddClick = () => {
    console.log("calling add click");
    navigate('/franchisee_user/masters/uoms/create');

  }



  const handleEditClick = (uomId) => {

    navigate('/franchisee_user/masters/uoms/edit/' + uomId);

  };

  const handleDeleteClick = (uomId) => {
    setDeleteUomId(uomId);

    fetchUom(uomId, function (result) {

      if ("uom" in result) {
        console.log("fetch uom", result.uom);

        // setDeleteUom(result.uom);
        const deleteUom = result.uom;

        Swal.fire({
          title: 'Are you sure?',
          html: `
        <p>You are about to delete the following uom:</p>
        <ul class="delete-details-list">
          <li class="details-row"><span><strong>Uom ID:</strong></span><span>${result.uom.id}</span></li>
          <li class="details-row"><span><strong>Uom Name:</strong></span><span>${result.uom.name}</span></li>
        </ul>
        <p>This action cannot be undone.</p>
      `,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33', // Red color for delete button
          cancelButtonColor: '#6c757d', // Gray color for cancel button
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {

            console.log("result", result);

            console.log("deleteAdress", deleteUom);

            destroyUom(deleteUom, function (result) {
              console.log("delete response", result);

              if ("uom" in result) {
                Swal.fire(
                  'Deleted!',
                  'Your record has been deleted.',
                  'success'
                );
                setDeleteUomId(null);
                setSaveCompleted(prevState => !prevState);

              }
              else if ("message" in result) {
                Swal.fire(
                  result?.response?.data?.message
                );
              }

            });
            // After successful deletion, you can show a success message

          }
        });
      }
    });

  };

  const cancelDelete = () => {
    setShowDeleteConfirmationModal(false);
    setDeleteUomId(null);
  }




  const handleCheckboxChange = (id, isChecked) => {
    setSelectedUomIds(prevSelectedIds => {
      const newSelectedIds = new Set(prevSelectedIds);
      if (isChecked) {
        newSelectedIds.add(id);
      } else {
        newSelectedIds.delete(id);
      }
      return newSelectedIds;
    });
  };

  const showMutipleDeleteConfirmation = () => {

    const deletingUoms = uomsList.data.filter(uom => selectedUomIds.has(uom.id));
    console.log("deletingUoms", deletingUoms);

    Swal.fire({
      title: 'Are you sure?',
      html: `
    <p>You are about to delete the following uoms:</p>
    ${deletingUoms.map(uom => {
        // Use an explicit return or an implicit return with parentheses
        return `
        <ul class="delete-details-list">
          <li class="details-row"><span><strong>Uom ID:</strong></span><span>${uom.id}</span></li>
          <li class="details-row"><span><strong>Uom Name:</strong></span><span>${uom.name}</span></li>
        </ul>
      `;
      }).join('')}
  `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33', // Red color for delete button
      cancelButtonColor: '#6c757d', // Gray color for cancel button
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        alert("confirm is called");
        console.log("result", result);
        const idsToDelete = Array.from(selectedUomIds);
        destroyUomsMultiple(idsToDelete, function (response) {

          console.log("destroyUomsMultiple", response);
          if ("uom" in response) {
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
            setEnableMultipleItemSelect(false);
            setSelectedUomIds(new Set());
            setSaveCompleted(prevState => !prevState);
          }
          else if ("message" in response) {
            Swal.fire(
              response?.response?.data?.message
            );
          }
        });

      }
    });
  }



  useEffect(() => {
    console.log("successMessage", successMessage);

    if (successMessage) {
      setShowToaster(true);
      setToaster({ type: 'success', heading: 'Success', message: successMessage });

    }

  }, []);

  useEffect(() => {
    document.title = 'Manage Uoms';
    let filters = {};
    filters["paginate"] = uomsList.paginate;
    filters["page"] = currentPage;
    filters["per_page"] = perPage;
    filters["search_term"] = searchTermCompleted;

    setViewDataLoading(true);
    getUoms(filters, function (response) {

      setViewDataLoading(false);
      console.log("calling uoms api", response);

      if ("uoms" in response) {
        setUomsList({
          paginate: true,
          per_page: perPage,
          data: response.uoms.data,
          current_page: response["uoms"].current_page,
          tot_page: response["uoms"].last_page,
        });
      }
      else {
        console.log("calling api error part");
        handleApiError(response);
      }


    });


  }, [currentPage, searchTermCompleted, saveCompleted, viewButtonToggle, perPage]);



  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>

      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}

          <AppBreadCrumb title='Uoms List'>
            <li>
              <a className="f-s-14 f-w-500" href="#">Admin</a>
            </li>
          
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">Uoms List</a>
            </li>

          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* Projects start */}
          <div className="row bg-white">
            <div className="col-12">
              <div className="tab-wrapper mb-3">
                <ul className="tabs">
                  <li className="tab-link active" data-tab={1}>All Uoms</li>
                  {/* <li className="tab-link" data-tab={2}>Attached Uoms</li>
                  <li className="tab-link" data-tab={3}>Not Attached Uoms</li> */}
                  <li className="ms-md-auto">
                    <div className="text-md-end d-flex flex-column flex-md-row mt-md-3">
                      {/* <button className="btn btn-primary w-100 h-45 icon-btn b-r-10 m-2" data-bs-target="#projectCard" data-bs-toggle="modal"><i className="ti ti-plus f-s-18" />Add Uom</button> */}


                      <AppSearchBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchTermCompleted={setSearchTermCompleted}></AppSearchBox>

                        <Can any={['create-uom']}>
                      <button class="text-nowrap btn btn-red btn-sm ms-md-3 fw-semibold f-s-14" type="button" onClick={() => handleAddClick()}><i class="ph-bold  ph-circles-three-plus"></i> Add Uom
                      </button>
                      </Can>

                      {/* <UomsReport reportLoading={reportLoading} setReportLoading={setReportLoading}></UomsReport> */}

                    </div>
                  </li>
                </ul>
              </div>
              <div className="content-wrapper" id="card-container">
                <div className="d-flex m-md-3">

                  {uomsList.data.length > 0 ?
                    (
                      <>
                        <AppPaginator entityName={entityName} currentPage={currentPage} totalPages={uomsList.tot_page} setCurrentPage={setCurrentPage}></AppPaginator>
                        <PerPageBlock perPage={perPage} setPerPage={setPerPage}></PerPageBlock>
                        <div className='d-none d-md-block text-end m-1'>
                          <button class="btn btn-info btn-sm" type="button" onClick={() => setEnableMultipleItemSelect(prevState => !prevState)}>{enableMultipleItemSelect ? (<i className="fa-solid fa-check fa-fw" />
                          ) : ''} Select</button>
                          {enableMultipleItemSelect && selectedUomIds.size > 0 ? (<button className="ms-2 btn btn-danger btn-sm" type="button" onClick={showMutipleDeleteConfirmation}> Delete Records</button>
                          ) : ''}

                        </div>
                      </>
                    ) : (
                      ''
                    )}


                  {(reportLoading || viewDataLoading) ? (<div class="loader_box ms-auto">
                    <div class="loader_14"></div>
                  </div>
                  ) : ''}
                </div>

                <div className="tabs-content active" id="tab-1">
                  <div className="row">
                    {!viewDataLoading &&
                      (uomsList.data.length ? (
                        uomsList.data.map((eachuom, index) => (
                          <div className="col-md-6 col-xl-4 project-card" key={index}>
                            {/* ... your existing JSX for a single uom card ... */}
                            <div className="card hover-effect" id="card1">

                              <div className="card-header">
                                <div className="d-flex align-items-center">
                                  {enableMultipleItemSelect ? (<input class="form-check-input me-2" id="inlineRadio1" type="checkbox" checked={selectedUomIds.has(eachuom.id)}
                                    onChange={(e) => handleCheckboxChange(eachuom.id, e.target.checked)}></input>) : ''}
                                  <div className="h-40 w-40 d-flex-center b-r-50 overflow-hidden">

                                 <div class="h-40 w-40 d-flex-center b-r-50 overflow-hidden me-2 btn-light-reddit"><i class="ti ti-scale f-s-18"></i> </div>
                                  </div>
                                  <a className="flex-grow-1 ps-2" href="project_details.html" target="_blank">
                                    <h6 className="m-0 text-dark f-w-600"> {eachuom.name}</h6>

                                  </a>
                                  <div className="dropdown">
                                    <button aria-expanded="false" className="bg-none border-0" data-bs-toggle="dropdown" type="button">
                                      <i className="ti ti-dots-vertical text-dark" />
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                      <li>
                                        <a className="dropdown-item" onClick={() => handleEditClick(eachuom.id)} >
                                          <i className="ti ti-edit text-success" /> Edit
                                        </a>
                                      </li>
                                     
                                         <li>
                                       
                                        <a className="dropdown-item delete-button" onClick={() => handleDeleteClick(eachuom.id)}>
                                          <i className="ti ti-trash text-danger" /> Delete
                                        </a>
                                      </li>
                                    
                                     

                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body">
                                <div className="d-flex">
                                  <div>
                                    <h6 className="text-dark f-s-14">Name : <span className="text-success">{eachuom.name} </span></h6>
                                    <h6 className="text-dark f-s-14">Short name: <span className="text-danger">{eachuom.short_name}</span></h6>
                                  
                                  </div>
                                  <div className="flex-grow-1 text-end">
                                    <p className="f-w-500 text-secondary">Id </p>
                                    <h6 className="f-w-600">{eachuom.id}</h6>
                                  </div>
                                </div>


                              </div>

                            </div>
                          </div>
                        ))
                      ) : (
                        <>
                          <div className="card mb-3  hover-effect">
                            <div className="row g-0">
                              <div className="col-md-6 col-xl-8">
                                <div className="card-body">
                                  <h5 className="card-title">No Uom Found</h5>
                                  <p className="card-text">No Records Found matching the input parameters</p>
                                </div>
                              </div>
                              <div className="col-md-6 col-xl-4">
                                <img alt="..." className="img-fluid" src="../assets/images/blog-app/09.jpg" />
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                  </div>
                </div>
                {/* <div className="tabs-content" id="tab-2">
               
                </div>
                <div className="tabs-content" id="tab-3">
                 
                </div> */}
              </div>
            </div>
          </div>
          {/* Projects end */}
        </div>
      </main>



      <Modal show={showDeleteConfirmationModal} onHide={cancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title className='mx-auto'>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this record? This action cannot be undone.

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button variant="danger" onClick={cancelDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <UomsForm
                entityName = {entityName}
                formType = {formType}
                currentUomId={currentUomId}
                showModal = {showModal}
                setShowModal = {setShowModal}
                setShowToaster={setShowToaster}
                setToaster={setToaster}
                setSaveCompleted={setSaveCompleted}
                handlecloseModal = {handlecloseModal}
                 ></UomsForm> */}

    </>
  )
}

export default UomsPage
